import Breadcrumb from "../Breadcrumb";
// import Percentage from "../../../assets/used-images/percentage.png";
// import OfferBox from "./components/offers/OfferBox";
import axios from "axios";
import TrCourseImg from "../../../assets/images/TrainingCoursesImg.png";
import TrainingCourseLoading from "../../loading/taining-course-box";
import { useLanguage } from "../../../store/language-context";
import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Offers = () => {
    const { URL } = useLanguage();
    const { t } = useTranslation();
    const { data: offers, isLoading, error } = useQuery({
        queryKey: ['offers', URL],
        queryFn: async () => {
            try {
                const response = await axios.get(`${URL}/offers`);
                return response?.data?.data?.data ?? response?.data?.data
            } catch (error) {
                throw new Error(t('custom.err'))
            }
        },
        retry: 0,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
    });

    return (
        <>
            <Breadcrumb pages={[t('routes.offers')]} />
            <main className="container">
                <section className="grid lg:grid-cols-3 relative !gap-10 py-12  px-4">
                    {isLoading && !error ? (
                        <TrainingCourseLoading />
                    ) : error || offers.length <= 0 ? (
                        <div className=" absolute top-10 z-50 bg-white flex justify-center items-center h-full w-full text-xl">
                            <p id="err">{t('custom.no-data')}</p>
                        </div>
                    ) : (
                        offers?.map((offer, i) => (
                            <Link to={`/offers/${offer?.id}`} key={offer?.id || i} className='relative group pt-7 pb-3 px-3 grid grid-cols-[35%_64%] border rounded-lg w-full max-lg:grid-cols-1 mb-5 mt-5'>
                                <div className='relative w-32 bg-transparent max-lg:h-18'>
                                    <div className='w-[7.5rem] h-[7.5rem] flex justify-center items-center absolute -top-14 inset-y-0 end-12 max-md:relative max-lg:h-28 max-lg:w-48 max-lg:relative'>
                                        <div className='bg-secondary-tw w-[7.8rem] h-[7.8rem] max-lg:h-[7.4rem] max-lg:w-[12.4rem] absolute z-0 rounded-lg'></div>
                                        <img src={offer?.image || TrCourseImg} alt='course-title' className='object-cover w-full relative z-10 h-full rounded-lg' />
                                        <div className="absolute -bottom-8 z-20 bg-secondary-tw rounded-md text-white px-2">
                                        <p className="m-0">{t('training-courses.discount-text')}</p>
                                            <p className="m-0">{offer?.discount}%</p>
                                            
                                        </div>
                                    </div>
                                </div>
                                <div className="space-y-2 flex flex-col justify-between">
                                    {offer?.title &&

                                        <p className='text-primary-tw text-xl truncate !text-start'>
                                            {offer?.title}
                                        </p>
                                    }
                                    {
                                        offer?.start_date &&
                                        <div className="flex items-center gap-2 text-sm">
                                            <span className="text-white bg-secondary-tw rounded-md px-2">
                                                {t('contact.start-date')} :
                                            </span>
                                            <span className="font-mono text-primary-tw">
                                                {offer.start_date}
                                            </span>
                                        </div>
                                    }
                                    {
                                        offer?.end_date &&
                                        <div className="flex items-center gap-2 text-sm">
                                            <span className="text-white bg-secondary-tw rounded-md px-2">
                                                {t('contact.end-date')} :
                                            </span>
                                            <span className="font-mono text-primary-tw">
                                                {offer.end_date}
                                            </span>
                                        </div>
                                    }
                                </div>
                            </Link>
                        ))
                    )}
                </section>
            </main>
        </>
    );
};

export default Offers;